import { Stack, Typography } from '@ethings/ui-toolkit';
import { Box, Card, styled, Theme } from '@mui/material';
import { ResponsiveStyleValue } from '@mui/system';
import chroma from 'chroma-js';
import { FC } from 'react';
import { DataCardProps } from '../../data-card/data-card.types';

interface ContainerProps {
  backgroundColor?: string;
}

interface PopoverDataRowProps extends DataCardProps {
  direction?: ResponsiveStyleValue<'row' | 'row-reverse' | 'column' | 'column-reverse'>;
}

const Container = styled(Card)<ContainerProps>(({ theme }: ContainerProps & { theme: Theme }) => ({
  position: 'relative',
  alignItems: 'center',
  borderRadius: theme.dataCard.borderRadius,
  background: theme.dataCard.background,
  color: theme.dataCard.contrastText,
  width: '100%',
  padding: `${theme.spacing(2)} ${theme.spacing(1.5)}`,
  '& .avatar': {
    width: '32px',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& img': {
      fontSize: theme.dataCard.avatarSize,
      maxWidth: '1em',
      maxHeight: '1em',
    },
    '& svg': {
      fontSize: '1.5rem',
    },
  },
  '& .content': {
    minWidth: 0,
    width: '100%',
  },
  '& .title': {
    whiteSpace: 'wrap',
    lineHeight: 1,
  },
  '& .label': {
    overflowX: 'hidden',
    textOverflow: 'ellipsis',
    lineHeight: 2.2,
    color: chroma(theme.dataCard.contrastText).alpha(0.7).hex(),
  },
}));

export const PopoverDataRow: FC<PopoverDataRowProps> = ({ avatar, label, title, direction = 'column', ...props }) => {
  return <Container data-testid={props['data-testid']} elevation={0}>
    <Stack alignItems='center' direction='row' gap={1} height='100%' >
      {avatar ? <Box className='avatar'>{avatar}</Box> : <></>}
      <Box className='content'>
        <Stack direction={direction}>
          {label
            ? <Typography
              data-testid={props['data-testid'] ? `${props['data-testid']}-label` : ''}
              className='label'
              component='div'
              variant='dataCardLabel'
            >
              {label}
            </Typography>
            : <></>
          }
          {title
            ? <Typography
              data-testid={props['data-testid'] ? `${props['data-testid']}-title` : ''}
              className='title'
              component='div'
              variant='dataCardTitle'
            >
              {title}
            </Typography>
            : <></>
          }
        </Stack>
      </Box>
    </Stack>
  </Container>;
};
